import React from "react";
import {NavLink} from "react-router-dom";

function TableCell(props) {

    function getValue() {
        if (typeof props.cell === 'boolean') {
            return props.cell ? 'Áno' : 'Nie'
        }
        if (Array.isArray(props.cell)) {
            return props.cell.map((item, index) =>
                <div key={index}>{item}</div>
            )
        }
        if (props.cell !== null) {
            return String(props.cell)
        } else {
            return null
        }
    }

    return (
        <td className="fieldWrapper" style={props.textStyle==="bold" ? {fontWeight: 'bold'}: {}}>
            {props.links && props.links[props.label] ? (
                <NavLink to={props.links[props.label]}>{getValue()}</NavLink>) : getValue()}
        </td>
    )
}

export default TableCell
